export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_GROUPS':
        case 'GET_GROUPS_FILTERS':
        case 'POSTING_GROUPS_FORM':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'GET_GROUPS_ERROR':
        case 'GET_GROUPS_FILTERS_ERROR':
        case 'POSTING_GROUPS_FORM_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        case 'GET_GROUPS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                groups: action.payload.groups
            })
        case 'GET_GROUPS_FILTERS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                categories: action.payload.categories,
                areas: action.payload.areas,
                when: action.payload.when,

            })
        case 'POSTING_GROUPS_FORMS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui
            })


        default:
            return state
    }
}
